import React from "react";

function Arrow({ side }) {
  return (
    <>
      {side === "left" ? (
        <div className="connector-arrow-left"></div>
      ) : (
        <div className="connector-arrow-right"></div>
      )}

      <div className="connector-arrow-down mobile-view-only"></div>
    </>
  );
}

export default Arrow;
